/* Due d'Arte — gedrag van het thema */
(function(){
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* header: transparant zolang de donkere opening in beeld is */
  const header = $("#dda-header");
  function headerTone(){
    if (!header) return;
    const hero = $(".open");
    header.classList.toggle("on-dark", !!hero && hero.getBoundingClientRect().bottom > 90);
  }
  /* naad die meeloopt bij het scrollen */
  function thread(){
    const th = $("#dda-thread"); if (!th) return;
    const top = th.getBoundingClientRect().top + window.scrollY;
    const max = document.body.scrollHeight - top - 400;
    th.style.height = Math.max(0, Math.min(max, window.scrollY + window.innerHeight * .6 - top)) + "px";
  }
  window.addEventListener("scroll", () => { headerTone(); thread(); }, { passive:true });
  headerTone(); thread();

  /* opening: elke 5 s een nieuw beeld; naam en beschrijving vloeien mee */
  const hero = $(".open[data-dda-hero]");
  if (hero){
    const slides = $$(".slide", hero), DUR = 5000;
    const lbl = $("#nowLbl", hero), nm = $("#nowName", hero), ds = $("#nowDesc", hero);
    let i = 0, timer, swapT;
    function go(n, restart){
      if (!slides.length) return;
      const prev = i;
      i = (n + slides.length) % slides.length;
      const s = slides[i];
      hero.style.setProperty("--hero-acc", s.dataset.acc);
      slides.forEach((el,k) => {
        el.classList.toggle("on", k === i);
        const v = $("video", el);
        if (v){ if (k === i){ v.currentTime = 0; const p = v.play(); if (p) p.catch(() => {}); } else if (k !== prev) v.pause(); }
      });
      if (lbl && restart !== "init"){
        lbl.classList.add("swap"); clearTimeout(swapT);
        swapT = setTimeout(() => { nm.textContent = s.dataset.name; ds.textContent = s.dataset.desc; lbl.href = s.dataset.url; lbl.classList.remove("swap"); }, 700);
      }
      if (restart !== false){ clearInterval(timer); if (slides.length > 1) timer = setInterval(() => go(i + 1, false), DUR); }
    }
    $$("video", hero).forEach(v => { v.muted = true; v.setAttribute("muted",""); v.removeAttribute("controls"); });
    go(0, "init");
  }

  /* serie-sectie: kleur van het monogram per serie */
  $$("[data-dda-series]").forEach(sec => {
    const btns = $$("[data-ser]", sec);
    btns.forEach(b => b.addEventListener("click", () => {
      sec.style.setProperty("--c-accent", b.dataset.color);
      $("#serName", sec).textContent = b.dataset.title;
      $("#serLine", sec).textContent = b.dataset.line || "";
      $("#serLink", sec).href = b.dataset.url;
      btns.forEach(x => x.setAttribute("aria-pressed", String(x === b)));
    }));
  });

  /* zachte scroll naar een anker */
  $$("[data-scroll]").forEach(b => b.addEventListener("click", () => { const t = $(b.dataset.scroll); if (t) t.scrollIntoView({ behavior:"smooth" }); }));

  /* sorteren op collectiepagina */
  const sort = $("#dda-sort");
  if (sort) sort.addEventListener("change", () => { const u = new URL(location.href); u.searchParams.set("sort_by", sort.value); location.href = u.toString(); });

  /* productpagina: opties → variant */
  const pf = $("[data-dda-product]");
  if (pf && $$("fieldset[data-opt]", pf).length){
    const variants = JSON.parse($("#dda-variants").textContent);
    const money = c => "€" + (c / 100).toFixed(2).replace(".", ",");
    function update(){
      const chosen = $$("fieldset[data-opt]", pf).map(fs => { const r = $("input:checked", fs); return r ? r.value : null; });
      const v = variants.find(x => x.options.every((o,k) => o === chosen[k]));
      const btn = $("#dda-add"), id = $("#dda-id"), price = $("#dda-price"), stock = $("#dda-stock");
      $$("[data-opt-label]", pf).forEach((el,k) => el.textContent = chosen[k] || "");
      if (!v){ btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      id.value = v.id; price.textContent = money(v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      stock.textContent = v.available ? stock.dataset.in : stock.dataset.out;
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    }
    pf.addEventListener("change", update);
    update();
  }
})();

/* ===== v2: menu en productreeks ===== */
(function(){
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  /* dropdowns: klik (en tik op gsm) opent, klik buiten sluit */
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-dd]");
    /* klik op de hoofdnaam: naar de pagina (met muis meteen; op aanraakscherm opent de eerste tik, de tweede gaat door) */
    if (b && b.dataset.href && (matchMedia("(hover: hover)").matches || b.parentElement.classList.contains("is-open"))){ location.href = b.dataset.href; return; }
    if (b){ const dd = b.parentElement, was = dd.classList.contains("is-open");
      $$(".dd.is-open").forEach(x => { x.classList.remove("is-open"); x.firstElementChild.setAttribute("aria-expanded","false"); });
      if (!was){ dd.classList.add("is-open"); b.setAttribute("aria-expanded","true"); } return; }
    if (!e.target.closest(".pan")) $$(".dd.is-open").forEach(x => x.classList.remove("is-open"));
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") $$(".dd.is-open").forEach(x => x.classList.remove("is-open")); });

  /* productreeks: schuift zonder stoppen; het stuk dat links in beeld komt bepaalt naam en kleur */
  const reel = $("[data-dda-reel]"); if (!reel) return;
  const tr = $("[data-reel-track]", reel), N = tr.children.length / 2; if (!N) return;
  const speed = +reel.dataset.speed || 46;
  const nm = $("[data-reel-name]", reel), ln = $("[data-reel-line]", reel), pr = $("[data-reel-price]", reel), lk = $("[data-reel-link]", reel);
  let off = 0, last = 0, cur = -1;
  function show(i){
    if (i === cur) return; cur = i; const s = tr.children[i];
    reel.style.setProperty("--reel-acc", s.dataset.acc);
    nm.textContent = s.dataset.name; nm.href = s.href; lk.href = s.href; ln.textContent = s.dataset.line; pr.textContent = s.dataset.price;
  }
  function tick(ts){
    const dt = last ? Math.min(64, ts - last) / 1000 : 0; last = ts;
    const step = tr.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 18);
    const slow = matchMedia("(prefers-reduced-motion: reduce)").matches ? .6 : 1;
    off = (off + speed * slow * dt) % (step * N);
    tr.style.transform = `translate3d(${-off}px,0,0)`;
    const k = Math.floor((off + step * .35) / step);
    $$(".slot", tr).forEach((el,j) => el.classList.toggle("on", j === k));
    show(k % N);
    requestAnimationFrame(tick);
  }
  show(0); requestAnimationFrame(tick);
})();
